// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillStealthActive, neutralForegroundHint, neutralForegroundRest } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../utils/enums";
import { profileHrColor } from "../../utils/commonJssConstants";

export const ProfileSubscriptionStyles = (config: DesignSystem) => ({
    profileSubscriptionsContainer: {
        "& .subs-history-title": {
            padding: "15px 24px",
            "font-size": "16px",
            "font-weight": "600",
            display: "flex",
            "border-top": "1px solid",
            "border-bottom": "1px solid",
            "border-color": profileHrColor,
            color: neutralForegroundRest
        },
        "& .cwt-subscriptions-fetch-error": {
            padding: "15px 24px",
            color: neutralForegroundRest
        }
    },

    profileSubscriptionsSuperAppContainer: {},
    subscriptionHistoryContainer: {
        "margin-bottom": "35px",
        "box-shadow": "0px 1.6px 3.6px rgba(0, 0, 0, 0.13), 0px 0px 2.9px rgba(0, 0, 0, 0.11)",
        "border-radius": "2px",
        "& .subs-empty-state-container": {
            width: "100%",
            height: "100px",
            display: "flex",
            "align-items": "center",
            "justify-content": "center",
            "text-align": "center",
            "& .empty-state-text": {
                "font-size": "24px",
                color: neutralForegroundHint
            }
        }
    },

    subscriptionContainer: {
        padding: "20px 24px",
        "border-bottom": "1px solid",
        "border-color": profileHrColor,
        "& .subs-body": {
            display: "flex",
            "flex-direction": "row",
            "align-items": "center",
            "& .publisher-info-container": {
                "font-size": "14px",
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "16px",
                "& .publisher-name": {
                    "font-weight": "600",
                    color: neutralForegroundRest
                },
                "& .publisher-address": {
                    color: neutralForegroundHint
                }
            },
            "& .subs-image-container": {
                height: "42px",
                width: "42px",
                "& .publisher-profile-img": {
                    height: "42px",
                    width: "42px",
                    "border-radius": "4px"
                }
            },
            "& .action-button-container": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "auto",
                "& button.button-active": {
                    "& .cwt-icon": {
                        "font-size": "18px",
                        [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "10px"
                    }
                }
            }
        },
        "& .subs-footer": {
            "margin-top": "20px",
            color: neutralForegroundHint,
            display: "flex",
            "align-items": "center",
            "font-size": "12px",
            "& .footer-tag": {
                padding: "5px 10px",
                background: neutralFillStealthActive,
                "border-radius": "4px",
                [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "12px"
            },
            "& .footer-action": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "auto",
                "& .transaction-history-trigger": {
                    cursor: "pointer",
                    display: "flex",
                    "& .cwt-title": {
                        [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "10px"
                    },
                    "& .cwt-icon": {
                        transition: ".2s ease-in-out"
                    },
                    "& .cwt-icon-rotated": {
                        transform: "rotate(180deg)"
                    }
                }
            }
        },
        "& .subs-transactions": {
            margin: "20px -24px 0",
            padding: "0 24px",
            transition: ".4s ease-in-out",
            "overflow-y": "hidden",
            "& .transaction-container": {
                margin: "0 -24px",
                display: "flex",
                "align-items": "center",
                color: neutralForegroundHint,
                "font-size": "13px",
                "border-top": "1px solid",
                "border-color": profileHrColor,
                padding: "20px 35px",
                "& .cwt-icon": {
                    [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "16px",
                    "font-size": "24px"
                },
                "&:last-child": {
                    "padding-bottom": "0"
                }
            }
        },
        "& .transactions-collapsed": {
            "max-height": "0",
            "margin-top": "0"
        },

        "& .transactions-expanded": {
            "max-height": "500px"
        },

        ["&." + enums.responsiveLevels.L0]: {
            "& .subs-body": {
                "flex-direction": "column",
                "align-items": "center",
                "& .publisher-info-container": {
                    [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0",
                    "text-align": "center",
                    "margin-top": "10px"
                },
                "& .action-button-container": {
                    "margin-top": "10px",
                    [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0"
                }
            },
            "& .subs-footer": {
                "flex-direction": "column",
                "align-items": "center",
                "& .payment-info": {
                    "margin-top": "20px"
                },
                "& .footer-action": {
                    "margin-top": "20px",
                    [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0"
                }
            }
        }
    }
});